<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Approved Incident's</strong>
                        <div class="card-header-actions">
                            <router-link to="/incident_master">
                                <b-button variant="info" size="sm" style="color: #fff;"><i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                    Back To Incident Master</b-button>
                            </router-link>
                        </div>
                    </div>

                    <div>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="3" label="Search:">
                                <b-input-group>
                                    <b-form-input v-model="filter" placeholder="Enter Vehicle number / Hub Name" @input="searchdata"></b-form-input>
                                    <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="6" label="Select Incident Level:">
                                    <b-form-checkbox-group 
                                    v-model="selectedLevels" 
                                    class="mt-1" 
                                    @input="searchdata">
                                    
                                    <b-form-checkbox 
                                      value="hub" 
                                      switch 
                                      class="custom-checkbox mb-1">
                                      Hub Level
                                    </b-form-checkbox>
                                    
                                    <b-form-checkbox 
                                      value="vehicle" 
                                      switch 
                                      class="custom-checkbox">
                                      Vehicle Level
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                    <!-- <span @click="changescheck()">
                                        <b-form-radio v-model="selectedLevels" value="hub" @input.native="searchdatalevels($event, 'hub')" name="some-radios">
                                            Hub Level
                                        </b-form-radio>
                                    </span>
                                  <b-form-radio v-model="selectedLevels1" value="vehicle" @input.native="searchdatalevels($event, 'vehicle')" name="some-radios1">
                                    Vehicle Level
                                  </b-form-radio> -->
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group label-cols-sm="4" label="Select Origin:">
                                <ejs-multiselect 
                                    id='multi_select2' 
                                    placeholder="Origin Listing" 
                                    v-model="valueWH" 
                                    :dataSource='optionsWH' 
                                    :showSelectAll='showSelectAll' 
                                    selectAllText="Select All" 
                                    unSelectAllText="Unselect All" 
                                    :fields='fieldWH' 
                                    :allowCustomValue='allowCustomValue' 
                                    enableGroupCheckBox="true" 
                                    mode="CheckBox" 
                                    @change="searchdata"
                                />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col>
                            <div class="text-right">
                               <h6><b>Total Records : <span style="color: red;">{{ totalRows }}</span></b></h6>
                            </div>
                        </b-col>
                    </b-row>

                    <div>
                        <b-table show-empty responsive :fields="fields" :items="approvedlist" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                              </div>
                              <template slot="ttr" slot-scope="row">
                                <div>
                                    {{ ((row.item.ttr?row.item.ttr.hours:'00' )|| '00').toString().padStart(2, '0') }}:
                                    {{ ((row.item.ttr?row.item.ttr.minutes:'00') || '00').toString().padStart(2, '0') }}                                                                     
                                  </div>
                              </template>
                              <template slot="vehicle_no" slot-scope="row">
                                <div>
                                    {{ row.item.hubvehicle }}
                                </div>
                                </template>
                                <template slot="incident_level" slot-scope="row">
                                <div>
                                    {{ row.item.incidentlevel }}
                                </div>
                                </template>
                                <template slot="incident_type" slot-scope="row">
                                <div>
                                    {{ row.item.incidenttype }}
                                </div>
                            </template>
                              <template slot="Action" slot-scope="row">
                                <b-button
                                  size="sm"
                                  data-toggle="tooltip"
                                  title="View Approved Incident"
                                  @click="viewopenincident(row.item)"
                                  :modalShow= modalShow
                                >View Button</b-button>
                            </template>
                        </b-table>
                    </div>

                    <b-modal title="View Approved Incident" v-model="modalShow" size="xl" hide-footer>
                        <template slot="default" slot-scope="{ hide }">
                            <b-row class="p-3">
                                <b-col sm="3">
                                    <span><b>Incident Level : - </b> <span  v-if="approvedincident && approvedincident.incidentlevel">{{approvedincident.incidentlevel}} level </span></span>
                                </b-col>
                                <b-col sm="3">
                                    <span><b>Incident Type : -</b> {{approvedincident.incidenttype}}</span>
                                </b-col>
                                <b-col sm="4">
                                    <div>
                                        <p><b>Time to Resolve : </b>{{ formattedTime }}</p> &nbsp;&nbsp;&nbsp;
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="p-3">
                                <b-col md="6">
                                    <div>
                                        <span v-if="approvedincident.incidentlevel === 'vehicle'"><b>Vehicle No. : -</b> {{approvedincident.hubvehicle}}</span>
                                        <span v-if="approvedincident.incidentlevel === 'hub'"><b>Hub Name. : -</b> {{approvedincident.hubvehicle}}</span>
                                        <br><br>
                                        <span><b>Incident name : -</b> {{approvedincident.incident_name}}</span>
                                        <br><br>
                                        <span><b>Incident ID : -</b> {{approvedincident.incident_id}}</span>
                                        <br><br>
                                        <span><b>Incident time : -</b> {{approvedincident.createddate | ConvertTime12hour()}}</span>
                                        <br><br>
                                        <span><b>Incident status : -</b> {{approvedincident.report_status}}</span>
                                    </div>
                                    <div class="mt-5">
                                        <h5>Incident images :- </h5>
                                        <div>
                                            <img :src="approvedincident.report_image" alt="images" width="70%" height="200px">
                                        </div>
                                    </div>
                                </b-col>

                                <b-col md="6">
                                    <div v-if="loadtotalRows!=0">
                                    <div class="text-center">
                                        <h5>LOAD STATUS</h5>
                                    </div>
                                    <b-table show-empty :fields="open_indifields" :items="loaditems" :busy="isBusymodel" responsive>
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                          </div>
                                    </b-table>
                                    </div>
                                    <div>
                                        
                                        <h5>Incident Video :- </h5>
                                        <div>
                                            <br>
                                            <b-embed  type="video" controls>
                                              <source :src="approvedincident.report_video">
                                            </b-embed>
                                        </div>
                                    </div>
                                </b-col>

                                <b-col md="12">
                                    <b-table show-empty responsive :fields="approvedfields" :busy="isBusyupdate" :items="updatecount" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :bordered="bordered">
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                          </div>
                                          <template slot="no_of_boxes" slot-scope="row">
                                                <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link"  v-if="row.item.no_of_boxes !=''" >
                                                    <span style="color:#1b8eb7"> {{row.item.no_of_boxes}}</span>
                                                
                                                </button>
                                                
                                          </template>
                                    </b-table>
                                </b-col>
                            </b-row>

                            <hr>
                            <br>
                            <footer class="float-right">
                                <b-button size="md" variant="danger" @click="cancel()"
                                    >cancel</b-button
                                    >
                            </footer>
                        </template>
                        <template slot="modal-footer" slot-scope="{ hide }">
                            <b-button size="sm" style="display:none">
                                  Cancel
                            </b-button>
                        </template>
                    </b-modal>

                    <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
        
                            <template slot="default" slot-scope="{ hide }">
                        <b-row>
                            <b-col sm="12" class="text-right">
                            <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                            </b-col>   
                            <b-col sm="12"> 
                            <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyLoad" >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                                </div>  
                                   <template slot="mpsvalue" slot-scope="row">
                                    <span>&#8377;{{row.item.mpsvalue}}</span>
                                    </template>
                                    <template slot="physicalweight" slot-scope="row">
                                    <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                    </template>
                                    <template slot="breadth" slot-scope="row">
                                    <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                                    </template>
                                    <template slot="length" slot-scope="row">
                                    <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                                    </template>
                                    <template slot="height" slot-scope="row">
                                    <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                                    </template>
                                
                            </b-table> 
                          </b-col>
                        </b-row> 
                            <b-row>
                            <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                            <b-pagination
                                    v-model="mpscurrentPage"
                                    :total-rows="mpstotalRows"
                                    :per-page="mpsperPage"
                                    class="my-0"
                                ></b-pagination>
                        
                            </b-col> 
                        </b-row>
                            <div class="col-md-12 pull-right"> 
                                    <div slot="footer" class="text-right">
                                    
                                        <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                                    </div>
                                    </div>
                            </template>
                            <template slot="modal-footer" slot-scope="{ cancel }">
                            <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
                                Cancel
                            </b-button>
                            </template>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            filter: null,
            fields: [
                { key: "report_id",  label: "SNO. "},
                { key: "vehicle_no",  label: "Vehicle Number/Hub Name"},
                { key: "incident_id",  label: "Incident Code"},
                { key: "incident_level",  label: "Incident Level"},
                { key: "incident_type",  label: "Incident Type"},
                { key: "incident_name",  label: "Incident Name"},
                { key: "report_status",  label: "Incident Status"},
                { key: "total_count",  label: "No Of Loads"},
                { key: "ttr",  label: "Time To Resolve"},
                { key: "Action",  label: "Action"},
            ],
            approvedlist :[],
            totalRows :0,
            isBusy :false,
            modalShow :false,
            approvedincident : {}, 
            open_indifields :[ 
                {key : 'total_count', label :'Total Count'},
                {key : 'ofd_count', label :'OFD Count'},
                {key : 'intransit_count', label :'Intransit Count'},
                // {key : 'rto_count', label :'RTO Count'},
                // {key : 'ndr_count', label :'NDR Count'},
            ],
            loaditems: [],
            loadtotalRows :0,
            isBusymodel : false,
            approvedfields : [
                { key: "report_id",  label: "SNO . "},
                { key: "load_id",  label: "Load ID"},
                { key: "no_of_boxes",  label: "No of Boxes"},
                { key: "load_status",  label: "Load Status"},
                { key: "ewaybill",  label: "Eway Bill"},
                { key: "vehicle_no",  label: "Vehicle No"},
                { key: "update_vehicle_no",  label: "Update Vehicle No", variant: 'success'}, 
                { key: "ewaybill_validity",  label: "Eway Bill Validity"},
                { key: "dispatch_date",  label: "Dispatch Date"},
                // { key: "toqtal_count",  label: "Revised EDD"},
                // { key: "EDD",  label: "EDD"},
            ],
            bordered:true,
            updatecount :[],
            isBusyupdate : false,
            mpsitems:[],
            mpscurrentPage:1,
            mpsperPage:10,
            mpstotalRows:0,
            mpsfields:[
                // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
                { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
                { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
                
                { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
                { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
                
                { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
                { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
                // { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                
            ],
            productdetailsModal:false,
            isBusyLoad:false,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],

            selectedLevels:null,
            selected_Levels:null,
            isEditing: false, 
            timeInput:'',
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();
        this.ApprovereportList();
        this.showWHlist()
    },
    computed: {
        formattedTime() {
        const hours = ((this.approvedincident.ttr?this.approvedincident.ttr.hours:'00') || '00').toString().padStart(2, '0');
        const minutes = ((this.approvedincident.ttr?this.approvedincident.ttr.minutes:'00') || '00').toString().padStart(2, '0');

        return `${hours}:${minutes}`;
        }

    },
    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Incident Master' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Incident Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        
        clearFilter(){
            this.filter=null;
            this.OpenreportList();
        },
        showWHlist:function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
              .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },
 
        viewopenincident :function (value){
            this.modalShow = true;
            this.approvedincident =[];
            this.approvedincident = value;
            this.timeInput = `${((this.approvedincident.ttr?this.approvedincident.ttr.hours:'00') || '00').toString().padStart(2, '0')}:${((this.approvedincident.ttr?this.approvedincident.ttr.minutes:'00') || '00').toString().padStart(2, '0')}`;
            this.VehicleloadList(value.report_id);
            this.updateapproveincident(value.report_id);
        },

        cancel : function () {
            this.modalShow = false;
        },

        searchdata(selected) {
             if (selected.length) {
                if (selected.includes('hub') && selected.includes('vehicle')) {
                    this.selected_Levels=null;
                } else if (selected.includes('hub')) {
                    this.selected_Levels='hub';
                } else if (selected.includes('vehicle')) {
                    this.selected_Levels='vehicle';
                }
             }
             else{
                this.selected_Levels=null;
             }
            this.ApprovereportList();
        },


        ApprovereportList : function () {
            
            this.approvedlist = [];
            this.totalRows = 0;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
          
            var filter = []
            if (this.filter) {
            
                filter.push(this.filter)
            }

            this.isBusy = true;
            const obj = {
                incidentlevel: this.selected_Levels,
                hubid:this.valueWH,
                searchparams:filter,
                report_status :"Approved"
            }

            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/incidentReportList`,obj)
            .then(result =>{
             
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.approvedlist = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue.length;
                } else {
                    this.approvedlist = [];
                    this.totalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        VehicleloadList : function (report_id) {
            this.loaditems = [];
            this.loadtotalRows = 0;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
         
            this.isBusymodel = true;
            const obj = {
                report_status :"Approved",
                vehicle_id : this.approvedincident.vehicle_id== null ? '0' : this.approvedincident.vehicle_id,
                report_id : report_id
            }
            console.log("obj",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleLoadCount`,obj)
            .then(result =>{
                
                this.isBusymodel = false;

                if (result.body.returnmsg === "Successful") {
                    this.loaditems = result.body.returnvalue;
                    console.log(this.loaditems)
                    this.loadtotalRows = result.body.returnvalue.length;
                } else {
                    this.loaditems = [];
                    this.loadtotalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        updateapproveincident : function (report_id) {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.updatecount = [];
            this.totalcount = 0;

            this.isBusyupdate = true;
            const obj = {
                report_id : report_id,
            }
            console.log(obj)
            // return false

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getReportAgainstLoad`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusyupdate = false;
                if (result.body.returnmsg==="Successful") {
                    this.updatecount = result.body.returnvalue;
                    this.totalcount = result.body.returnvalue.length;
                } else {
                    this.updatecount = [];
                    this.totalcount = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        viewProduct:function(value){
            this.productdetailsModal=true;
            this.isBusyLoad = true;
            this.mpsitems  = [];
                    this.mpstotalRows = 0;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData); 
            let obj = {
                parentawb: value.load_id,
            }
            this.$http
                .post(
                    `${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
                .then(result => {
                    console.log("TTTTT",result);
                    this.isBusyLoad = false;
                    if(result.body.returnmsg === "successful"){
                    
                    this.mpsitems  = result.body.returnvalue;
                    // console.log("HHHHH",this.mpsitems);
                        this.mpstotalRows = result.body.returnvalue.length
                        // console.log("RRRRR",this.mpstotalRows);
                    
                    }else {
                    this.mpsitems  = [];
                    this.mpstotalRows = 0;
                    }
                }).catch(ex => {
                    console.log('error', ex)
                })
                
      },
      modalCancel:function(){
        this.productdetailsModal=false;
      },
    },
}
</script>